import { isPostcodeValid } from "./containers/PostcodeContainer/Postcode";
import { coreLibraryInitialised } from "../common/util";
import { POSTCODE_SERVICE_EVENTS } from "../common/constants";

export function setPostcode(postcode: string) {
  if (!isPostcodeValid(postcode)) {
    return Promise.reject(`Invalid postcode: "${postcode}"`);
  }

  if (coreLibraryInitialised()) {
    // @ts-ignore
    GlamCornerCore.bus.broadcast(POSTCODE_SERVICE_EVENTS.SET_POSTCODE, { postcode });
    return (global as any).GlamCornerCore.gcSession.setSessionValues({ postcode });
  } else {
    return Promise.resolve();
  }
}
